import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

import * as enums from '../enums'

export const TRANSFORMER = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.extra.space.Record.FunctionalUsage.Update,
    graphql.schema.SpaceRecordFunctionalUsageUpdate
  >({
    functionalizationMethodology: graphql.transformers.IN.nonNull(
      enums.SPACE_RECORD_FUNCTIONAL_METHODOLOGY,
    ),
    functionalizations: {
      usingFullInput: graphql.transformers.IN.if(
        (update: ents.extra.space.Record.FunctionalUsage.Update) =>
          update.functionalizationMethodology ===
          ents.extra.space.Record.FunctionalUsage.Methodology.Manual,
        graphql.transformers.IN.select(
          'functionalizations',
          graphql.transformers.IN.nullable(
            graphql.transformers.IN.list(
              graphql.transformers.IN.nonNull(
                graphql.transformers.IN.object({
                  functionId: transformers.PASS_THROUGH,
                  percent: transformers.PASS_THROUGH,
                }),
              ),
            ),
          ),
        ),
        graphql.transformers.IN.always(undefined),
      ),
    },
    serviceCenterId: graphql.transformers.IN.nullable(
      graphql.transformers.IN.validate(
        transformers.PASS_THROUGH,
        ents.extra.space.ServiceCenter.Id.isId,
      ),
    ),
  }),
)
